export const NAIRA_SIGN = "₦";

export const formatMoney = (amount, koboRes = true, currencySymbol = NAIRA_SIGN) => {
  if (amount == null || amount === "") return null;
  //ensure all commas are striped from the amount
  amount = String(amount).replace(/,/g, "");
  const numericAmount = Number(amount);
  const safeAmount = Number.isFinite(numericAmount) ? numericAmount : 0;
  //split the amount into naira and kobo
  //format the naira and add the kobo at the end of the process
  amount = safeAmount.toFixed(2).split(".");
  let naira = amount[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  let kobo = String(amount[1]);
  if (!kobo || kobo === "undefined") kobo = "00";
  return koboRes
    ? `${currencySymbol} ${naira || "0"}.${kobo}`
    : `${currencySymbol}${naira || "0"}`;
};

/** Prefer API signed_amount; else magnitude + action (DEBIT => negative). */
/**
 * Formats a controlled amount field with thousand separators (same grouping as formatMoney naira).
 * Use with type="text" and inputMode="decimal". Submit with parseAmountInputToNumber.
 */
export const formatAmountInputDisplay = (raw) => {
  let s = String(raw ?? "").replace(/,/g, "").replace(/[^\d.]/g, "");
  const firstDot = s.indexOf(".");
  if (firstDot !== -1) {
    s = s.slice(0, firstDot + 1) + s.slice(firstDot + 1).replace(/\./g, "");
  }
  const parts = s.split(".");
  const wholeRaw = parts[0] ?? "";
  const fracRaw = (parts[1] ?? "").slice(0, 2);
  const withCommas = wholeRaw.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  if (firstDot !== -1) {
    if (s.endsWith(".") && fracRaw === "") return `${withCommas}.`;
    return `${withCommas}.${fracRaw}`;
  }
  return withCommas;
};

export const parseAmountInputToNumber = (display) => {
  const n = parseFloat(String(display ?? "").replace(/,/g, "").trim());
  return Number.isFinite(n) ? n : NaN;
};

export const getTransactionSignedAmountForDisplay = (row) => {
  const hasSigned =
    row?.signed_amount !== undefined &&
    row?.signed_amount !== null &&
    row?.signed_amount !== "";
  if (hasSigned) {
    const n = Number(row.signed_amount);
    return Number.isFinite(n) ? n : 0;
  }
  const raw = Number(String(row?.amount ?? 0).replace(/,/g, ""));
  const abs = Math.abs(Number.isFinite(raw) ? raw : 0);
  const actionUpper = (row?.action || "").toString().toUpperCase();
  if (actionUpper === "DEBIT") return -abs;
  return abs;
};
